import { connect } from 'react-redux';

import geofences from 'APP_ROOT/data/geofences';

import Name from './Name';

const mapStateToProps = (state, ownProps) => {
    return {
        value: geofences.Selectors.geofenceName(state, ownProps.geofenceId),
        pending: geofences.Selectors.geofenceNameChangePending(state, ownProps.geofenceId),
        maxLength: geofences.GEOFENCE_NAME_MAX_LENGTH,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChange: (name) => dispatch(
            geofences.Actions.setGeofenceName(ownProps.stage, ownProps.geofenceId, name)
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Name);
